import React from "react";
import Navbar from "../../components/NavBar/Navbar";


export default function Events(){

    return(
        <div className='container-xl bg-white'>
            <Navbar/>
            <h1>Esta es la ruta Events</h1>
           </div>
    )
}